import axios from "../axios";
import { multiPosGiftGroupsURL } from "../requests";
import { ModifyMultiPosGiftGroupsPayload } from "../../types";

export const modifyMultiPosGiftGroupsApi = (
  token: string,
  payload: ModifyMultiPosGiftGroupsPayload[]
) => {
  return axios.put(
    multiPosGiftGroupsURL,
    { gift_lists: payload },
    {
      headers: {
        token,
      },
    }
  );
};
